import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardCard from './DashboardCard';
import {
  StatValue, StatRow, StatSub, ListRow, RowMain, RowName, StatLabel, TagChipRow, TagChip,
} from '../styles';

// PoolStatus — aktif havuz sayısı + havuz başına üye (üyeye göre sıralı, ilk 5)
// + etiket dağılımı (ilk 6 çip). Ayrıntılı liste zaten Yetenek Havuzu
// sayfalarında var — burada yalnız özet.
export default function PoolStatusCard({ poolStatus, loading }) {
  const { t } = useTranslation();

  const activePoolCount = poolStatus?.activePoolCount || 0;
  const membersByPool = poolStatus?.membersByPool || [];
  const tagDistribution = poolStatus?.tagDistribution || [];

  return (
    <DashboardCard
      title={t('talent.dashboard.pool.title')}
      span={4}
      spanMd={6}
      loading={loading}
      empty={activePoolCount === 0}
      emptyText={t('talent.dashboard.pool.empty')}
    >
      <StatRow>
        <StatValue>{activePoolCount}</StatValue>
        <StatSub>{t('talent.dashboard.pool.activePools')}</StatSub>
      </StatRow>

      <div style={{ marginTop: 14 }}>
        {membersByPool.slice(0, 5).map((p) => (
          <ListRow key={p.poolId}>
            <RowMain><RowName>{p.poolName}</RowName></RowMain>
            <StatSub>{t('talent.dashboard.pool.members', { count: p.memberCount })}</StatSub>
          </ListRow>
        ))}
      </div>

      {tagDistribution.length > 0 && (
        <div style={{ marginTop: 14 }}>
          <StatLabel>{t('talent.dashboard.pool.tagsLabel')}</StatLabel>
          <TagChipRow>
            {tagDistribution.slice(0, 6).map((tg) => (
              <TagChip key={tg.tagId}>{tg.tagName} · {tg.count}</TagChip>
            ))}
          </TagChipRow>
        </div>
      )}
    </DashboardCard>
  );
}
